/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


// sticky header body calibration
function set_height_offset() {
  if ( $(window).width() > 767 ) {
    var height_offset = $('#shopify-section-header').outerHeight();
  } else {
    var height_offset = $('#shopify-section-header').outerHeight() + $('#shipping-state-containter').outerHeight();  
  }
  $('div.main').css('margin-top', height_offset);
}


$(function(){

  // adjust content offset on page load and resize
  set_height_offset();
  window.onresize = function() {
    set_height_offset();
  }

  setTimeout(function(){
    set_height_offset();
  }, 200);


  // default set input fields for mini
  setTimeout(function(){
    var num = parseInt($('#productSelect-1-option-1').val()?.split(/ (.*)/)) || 0;
    if($(body).attr('id') == 'dainty-heart-mini-bottles') {
      var num = num * 2;
    }
    $('.mini-input-fieldset').each(function(){
      if( $(this).attr('data-fieldset') <= num ) {
        $(this).find('input').prop('disabled', false)
        $(this).show();
      } else {
        $(this).find('input').prop('disabled', true)
        $(this).hide();
      }
    });
  },500);


  // on change set input fields for mini
  $('#productSelect-1-option-1').on('change', function(){
    var num = parseInt($(this).val().split(/ (.*)/));
    if($(body).attr('id') == 'dainty-heart-mini-bottles') {
      var num = num * 2;
    }
    $('.mini-input-fieldset').each(function(){
      if( $(this).attr('data-fieldset') <= num ) {
        $(this).find('input').prop('disabled', false)
        $(this).show();
      } else {
        $(this).find('input').prop('disabled', true)
        $(this).hide();
      }
    });
  });


  // move customily inputs above gift option
  setTimeout(function(){
    var target = $('#customily-options');
    target.parent().prepend(target);
  },1000);


  // force php photo update on button/wine type change
  $('#pdp-wine-filter').on('click', 'button', function() {
    $('#productSelect-1-option-0').trigger('change');
  });


  // shipping state select

  // UI
  $('#shipping-state-trigger').on('click', function(){
    $('#shipping-state-selector').slideToggle();
  });

  // see if state passed in through URL
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const presetState = urlParams.get('shipto')
  
  // check if product page
  const is_product_page = $('body').hasClass('template-product');

  // pull state from localStorage
  let local_state = localStorage.getItem("shipToState");
  console.log("local_state: " + local_state)

  // if state is in URL, override the localStorage state
  //alert('preset: ' + presetState)
  if (presetState) {
    local_state = presetState;
    localStorage.setItem("shipToState", presetState);
  }

  // Preset state
  if (local_state) {
    if (local_state === 'TX' || local_state === 'IL' || local_state === 'NY') {
      $('#shipping-state').val(local_state);
    } else {
      localStorage.removeItem("shipToState");
    }
  }

  // Select state logic
  $('#shipping-state').on('change', function(){
    let the_state = $('#shipping-state').val();
    localStorage.setItem("shipToState", the_state);
    if(the_state === 'TX' || the_state === 'IL' || the_state === 'NY') {
      if (is_product_page) {
        $('#shipping-state-atc-notice').remove();
      }
    } else if (the_state === 'CA') {
      setTimeout(function(){
        window.location.href = "https://personalize3.williams-sonoma.com" + window.location.pathname + "?shipto=" + the_state;
      }, 500);
    } else {
      setTimeout(function(){
        var redirectUrl = "https://personalize.williams-sonoma.com" + window.location.pathname + "?shipto=" + the_state;

        // Add isSpirit parameter if on a product page with "spirits" tag
        if (is_product_page) {
          var productJson = $('#ProductJson-1').html();
          if (productJson) {
            var product = JSON.parse(productJson);
            if (product.tags && product.tags.includes('spirits')) {
              redirectUrl += "&isSpirit=1";
            }
          }
        }

        window.location.href = redirectUrl;
      }, 500);
    }
  });
 
  if (is_product_page && local_state === null) {
    $('<p id="shipping-state-atc-notice">Please select a shipping state before adding items to the cart.</p>').insertBefore($('.product-single__add.js-product-buttons'));
  }

  // check to see if state has been selected before allowing them to add to cart
  $('form.product-single__form').on('submit', function(event) {  
    //refresh local_state value
    local_state = localStorage.getItem("shipToState");  
    if (is_product_page && local_state === null) {
      event.preventDefault();
      $('#shipping-state-atc-notice').hide().fadeIn();
    }
  })

});
